import { styled } from 'styled-components'
import { onLargeScreen, onMediumScreen } from 'mixtiles-web-common'

export const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  * {
    box-sizing: border-box;
  }
`

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0 12px;
  align-items: center;
  margin-bottom: 20px;
`

export const Header = styled.span<{ $aiEnabled: boolean }>`
  color: ${({ theme }) => theme.colors.secondaryDark};
  font-size: 26px;
  font-weight: 600;
  line-height: 114%;
  letter-spacing: -0.05px;
  text-align: center;
  margin: ${({ $aiEnabled }) =>
    $aiEnabled ? '40px 0 28px 0' : '98px 0 28px 0'};
  max-width: 220px;
  ${onMediumScreen} {
    max-width: 620px;
    font-size: 30px;
    margin: 90px 0 30px 0;
  }
  ${onLargeScreen} {
    max-width: 620px;
    font-size: 36px;
    margin: 120px 0 40px 0;
  }
`

export const ProductsContainer = styled.div`
  display: flex;
  gap: 14px;
  flex-direction: column;
  width: 100%;
  ${onMediumScreen} {
    align-items: center;
    justify-content: center;
    flex-direction: row;
    gap: 20px;
  }
`

export const ProductImage = styled.img`
  max-height: 150px;
  max-width: 100%;
  padding-bottom: 0;
  ${onMediumScreen()} {
    box-sizing: content-box;
    padding-bottom: 40px;
    max-height: 252px;
  }
  transition: transform 0.3s ease;
`

export const ProductHeader = styled.span<{
  $withTextShadow?: boolean
}>`
  color: ${({ theme }) => theme.colors.black};
  transition: color 0.3s ease;
  font-size: 22px;
  font-weight: 600;
  line-height: 130%;
  ${onMediumScreen()} {
    font-size: 26px;
  }
  ${onLargeScreen()} {
    font-size: 32px;
  }
`

const PRODUCT_CONTAINER_DESKTOP_WIDTH = 360
const PRODUCT_CONTAINER_DESKTOP_HEIGHT = 405

export const ProductContainer = styled.div<{
  $isPhotoBooks?: boolean
}>`
  max-width: 352px;
  width: 100%;
  height: 150px;
  background-color: ${({ theme }) => theme.colors.white};
  color: ${({ theme }) => theme.colors.black};
  display: flex;
  align-self: center;
  align-items: center;
  border-radius: 25px;
  padding-left: 32px;
  margin: 0 19px 0 19px;
  overflow: hidden;
  cursor: pointer;
  box-sizing: border-box;
  justify-content: space-between;
  ${onMediumScreen()} {
    padding-left: 0;
    padding-top: calc(56px * 0.75);
    flex-direction: column;
    align-items: center;
    gap: calc(15px * 0.75);
    height: calc(${PRODUCT_CONTAINER_DESKTOP_HEIGHT}px * 0.75);
    width: calc(${PRODUCT_CONTAINER_DESKTOP_WIDTH}px * 0.75);
    transition: background-color 0.3s ease;

    &:hover {
      ${ProductHeader} {
        color: ${({ theme }) => theme.colors.primaryAccent};
      }
    }
  }
  ${onLargeScreen()} {
    gap: 15px;
    padding-top: 56px;
    width: ${PRODUCT_CONTAINER_DESKTOP_WIDTH}px;
    height: ${PRODUCT_CONTAINER_DESKTOP_HEIGHT}px;
  }
`
